import currency from "currency.js";

export default{
    formatCurrency(number, decimals)
    {
        var decimalPlaces = 2;
        if (decimals || decimals === 0)
            decimalPlaces = decimals;
        var sek = value =>
            currency(value, {
                pattern: `# !`,
                negativePattern: `-# !`,
                symbol: "kr",
                separator: " ",
                decimal: ",",
                precision: decimalPlaces
            });
        return sek(this.round(number, decimalPlaces)).format();
    },
    formatPercentage(number, decimals)
    {
        var decimalPlaces = 2;
        if (decimals || decimals === 0)
            decimalPlaces = decimals;
        var percentage = value =>
            currency(value, {
                pattern: `# !`,
                negativePattern: `-# !`,
                symbol: "%",
                separator: " ",
                decimal: ",",
                precision: decimalPlaces
            });
        return percentage(this.round(number, decimalPlaces)).format();
    },
    formatCustom(number, decimals, suffix)
    {
        var decimalPlaces = 2;
        if (decimals || decimals === 0)
            decimalPlaces = decimals;
        var custom = value =>
            currency(value, {
                pattern: `# !`,
                negativePattern: `-# !`,
                symbol: suffix,
                separator: " ",
                decimal: ",",
                precision: decimalPlaces
            });
        return custom(this.round(number, decimalPlaces)).format();
    },
    // Rounds a number correctly to two decimals:
    // https://stackoverflow.com/questions/10768083/tofixed2-rounds-x-525-inconsistently
    // This method guarantees that if value is more than .005 then it will round up!
    // Example if numberToRound = 5.525 then it will return 5.53
    round(numberToRound, decimals)
    {
        var decimalPlaces = 2;
        if (decimals || decimals === 0)
            decimalPlaces = decimals;
        var factor = Math.pow(10, decimalPlaces);
        var roundedNumberString = Math.round(numberToRound * factor) / factor;
        var roundedNumber = parseFloat(roundedNumberString);
        return roundedNumber;
    }
}